import * as React from "react";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { TextField, Tooltip, TextFieldProps } from "@material-ui/core";

// Classes
import Utility from "../../domain/classes/Utility";

// NPM
import { animated } from "react-spring/renderprops-universal";
import clsx from "clsx";

export const styles = (theme: Theme) =>
	createStyles({
		root: {},
	});

export interface PromptedTextFieldProps {
	title: string;
}

const PromptedTextField = React.forwardRef<
	HTMLInputElement,
	PromptedTextFieldProps & WithStyles<typeof styles> & TextFieldProps
>(({ title, classes, className, ...textFieldPicker }, ref) => {
	return (
		<Tooltip title={title} placement="top" arrow>
			<TextField
				{...textFieldPicker}
				className={clsx(classes.root, className)}
				ref={ref}
			/>
		</Tooltip>
	);
});

const StyledPromptedTextField = withStyles(styles, {
	classNamePrefix: Utility.generateClassName("PromptedStyledTextField"),
})(PromptedTextField);

export default StyledPromptedTextField;

export const AnimatedPromptedTextField = animated(StyledPromptedTextField);
